import { appInformation } from './app';

//   process.env.REACT_APP_BRANCH != 'master';
export const enableTestEnvironment: boolean =
  appInformation.branch_cicd === 'stage' ||
  appInformation.branch_cicd === 'develop';

export const multiBranchFeat: boolean = true;